import React, { useMemo } from 'react';
import { Col, Row } from 'react-styled-flexboxgrid';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { eyebrowMStyles, eyebrowXsStyles, headerXsStyles, headerXxsStyles } from '../../../styles/typography';
import { bpWidthTailwind, colors } from '../../../styles/variables';
import { renderRichTextReact } from '../../../utils/storyblokRichText';

export const CaptionHeading = styled.h2`
  ${headerXxsStyles};
  color: ${({ darkMode }) => (darkMode ? colors.beige100 : undefined)};
  font-size: 16px;
  margin-top: 25px;

  @media (${bpWidthTailwind.desktopSm}) {
    ${headerXsStyles};
    color: ${({ darkMode }) => (darkMode ? colors.beige100 : undefined)};
    margin-top: 50px;
  }
`;

export const Caption = styled.div`
  ${eyebrowXsStyles};
  color: ${({ darkMode }) => (darkMode ? colors.orange200 : undefined)};
  margin-top: 12px;

  @media (${bpWidthTailwind.desktopSm}) {
    ${eyebrowMStyles};
    color: ${({ darkMode }) => (darkMode ? colors.orange200 : undefined)};
    margin-top: 20px;
  }
`;

const Slider4Item = ({ blok, darkMode }) => {
  const { captionHeading, caption, asset } = blok;

  const captionHeadingRichText = useMemo(() => renderRichTextReact(captionHeading), [captionHeading]);
  const captionRichText = useMemo(() => renderRichTextReact(caption), [caption]);

  return (
    <div {...storyblokEditable(blok)} className="w-[326px] sm:w-[450px] lg:w-[500px] mx-4 md:mx-5">
      {asset?.map((nestedBlok) => (
        <Row key={nestedBlok._uid}>
          {blok.linkable ? (
            <a href={blok.link?.url} rel="noreferrer" target="_blank">
              <StoryblokComponent blok={nestedBlok} />
            </a>
          ) : (
            <StoryblokComponent blok={nestedBlok} />
          )}
        </Row>
      ))}
      {(captionHeadingRichText || captionRichText) && (
        <Row>
          <Col xs={8} md={10} lg={12}>
            {blok.linkable && captionHeadingRichText && (
              <a href={blok.link?.url} rel="noreferrer" target="_blank">
                {captionHeadingRichText && (
                  <CaptionHeading darkMode={darkMode}>{captionHeadingRichText}</CaptionHeading>
                )}
              </a>
            )}
            {!blok.linkable && captionHeadingRichText && (
              <CaptionHeading darkMode={darkMode}>{captionHeadingRichText}</CaptionHeading>
            )}
            {captionRichText && <Caption darkMode={darkMode}>{captionRichText}</Caption>}
          </Col>
        </Row>
      )}
    </div>
  );
};

Slider4Item.propTypes = {
  blok: PropTypes.object.isRequired,
  darkMode: PropTypes.bool,
};

export default Slider4Item;
